export const slidesExtensionPrivacyPolicyData = [{
    header: "",
    content: 
            <div>
                <b>Last Updated:</b> August 12, 2026
            </div>
}, {
    header: "",
    content: 
            <div>
                At <b>Easy Image to Text</b>, we respect your privacy and are committed to protecting the information you share with us. This Privacy Policy explains how we collect, use, store, and protect your data when you use our platform.
                <br/>
                This site hosts multiple tools. See the relevant privacy notices below.
            </div>
}, {
    header: "Consent",
    content: 
            <div>
                By using Easy Image to Text or its Google Slides extension <b>Convert PDF to Google Slides™</b>, you agree to the collection and use of information in accordance with this Privacy Policy.
            </div>
}, {
    header: "Information We Collect",
    content: 
            <>
                <div>
                    We collect only the minimal data necessary for the proper functioning of our service. The types of data we collect include:
                </div>
                <div className="infoWCdiv">
                    <div>a) Uploaded PDFs</div>
                    <ul>
                        <li>
                            Any PDF uploaded for conversion are <b>processed temporarily</b> and deleted automatically when the page is reloaded or when the user navigates away.
                        </li>
                        <li>
                            We do <b>not store, share, or distribute</b> uploaded files.
                        </li>
                    </ul>
                </div>
                <div className="infoWCdiv">
                    <div>b) Log Data (Automatically Collected)</div>
                    <div className="logDataDiv1">To improve our service, we collect basic log data when you access the platform, such as:</div>
                    <ul>
                        <li>IP address</li>
                        <li>Browser type and version</li>
                        <li>Device information</li>
                        <li>Date and time of access</li>
                        <li>Pages visited</li>
                    </ul>
                    <div>This data is used only for analytics and troubleshooting purposes.</div>
                </div>
                <div className="infoWCdiv">
                    <div>c) Contact Information</div>
                    <div>If you contact us via email or support forms, we may collect your name, email address, and message content to respond to your inquiries.</div>
                </div>
                <div className="infoWCdiv last">
                    <div>d) Google Account Information</div>
                    <div>When you install and use our Google Slides extension, we collect your primary Google Account email address and basic profile information (such as your name). We use this strictly to authenticate your account, manage your usage limits, and provide the service.</div>
                </div>
            </>
}, {
    header: "How We Use Your Information",
    content: 
            <>
                <div>We use collected data solely to:</div>
                <ul>
                    <li>Provide, maintain and improve our AI-powered PDF to Google Slide conversion service.</li>
                    <li>Enhance <b>user experience</b> and site functionality.</li>
                    <li>Prevent <b>fraud, abuse, or security risks</b>.</li>
                    <li>Respond to customer support requests.</li>
                </ul>
                <div>We <b>never sell or rent your personal data</b>.</div>
            </>
}, {
    header: "Data Storage & Security",
    content: 
            <ul>
                <li><b>Uploaded files are not stored</b> beyond the processing session.</li>
                <li>We use <b>secure transmission (HTTPS)</b> to protect your data during processing.</li>
                <li>Any personal data (such as user emails sent to us) is received only by the admin and treated with confidentiality.</li>
            </ul>
}, {
    header: "Compliance with Google Workspace Limited Use Policy",
    content: 
            <ul>
                <li>"Easy Image to Text" and its Google extensions do not use any data obtained from Google Workspace APIs (such as Google Slides) or Google Photos APIs to train or improve AI or ML models, whether generalized or personalized.</li>
                <li>The use of raw or derived user data received from Workspace APIs will adhere to the <a href="https://developers.google.com/workspace/workspace-api-user-data-developer-policy" target="_blank">Google User Data Policy</a>, including the Limited Use requirements.</li>
            </ul>
}, {
    header: "Third-Party Services & Cookies",
    content: 
            <>
                <ul>
                    <li>We may use <b>Google Analytics</b> or similar tools to track website usage trends.</li>
                    <li>Third-party <b>advertisements</b> (if applicable) may be displayed, but we do not share user data with advertisers.</li>
                    <li>We use <b>cookies</b> only to improve your browsing experience.</li>
                    <li>Users can control or disable cookies and analytics tracking through their browser settings.</li>
                </ul>
            </>
}, {
    header: "Your Rights",
    content: 
            <>
                <div>As a user, you have the right to:</div>
                <ul>
                    <li><b>Contact us</b> anytime to request deletion of any personal information you’ve shared with us, such as emails or messages.</li>
                    <li><b>Control or disable cookies and analytics tracking</b> via your browser settings.</li>
                    <li><b>Contact us</b> for any privacy-related concerns.</li>
                </ul>
                <div>To make a request, please email us at <span className="emailId">support@easyimagetotext.com</span></div>
            </>
}, {
    header: "Changes to This Policy",
    content: 
            <div>
                We may update this Privacy Policy from time to time. Any changes will be reflected on this page with the updated date. Continued use of the service after changes constitutes acceptance of the new terms.
            </div>
}, 
{
    header: "Contact Us",
    content: 
            <div>
                If you have any questions regarding this Privacy Policy, please contact us at:
                📧  <span className="emailId">support@easyimagetotext.com</span>
            </div>
}, {
    header: "",
    content: 
            <div>
                By using <b>Easy Image to Text</b> or <b>Convert PDF to Google Slides™</b>, you agree to this Privacy Policy.
            </div>
}]